module.exports = __webpack_public_path__ + "media/images/flags/cg-3ecee2a911defd697d79a1efd6b59686.svg";